import { create } from 'zustand';
import { persist } from "zustand/middleware";

type State = {
  menuSeleccionado: 'MENU_ADMINISTRACION' | 'MENU_MAPA';
};

type Actions = {
  setMenuSeleccionado: (menu: State['menuSeleccionado']) => void;
};

export const useAppStore = create(
  persist<State & Actions>(
    (set) => ({
      menuSeleccionado: 'MENU_MAPA',
      setMenuSeleccionado: (menu) => set({ menuSeleccionado: menu }),
    }),
    {
      name: "app",
    }
  )
);